// frontend/src/services/fotoPerfil.js
//
// A foto do usuario logado para o ICONE do sistema (ex.: o circulo no canto da Dashboard).
//  - Busca a foto UMA vez por sessao (GET /api/perfil) e guarda na memoria da pagina, junto com o id do usuario dono dela:
//    se outra pessoa entrar no mesmo navegador, a foto de quem saiu NUNCA aparece para ela.
//  - A pagina "Meu Perfil" avisa (avisarFotoPerfil) quando a foto e salva ou removida, e o icone troca na hora, sem recarregar.
//  - Qualquer falha (sem rede, sem foto, imagem quebrada) deixa o icone como sempre foi: a inicial do nome.

import React, { useEffect, useState } from 'react';
import { carregarPerfil } from './perfilApi';

let estado = { id: null, foto: null, pronto: false };
let emVoo = null; // { id, promessa }
const ouvintes = new Set();

function notificar() {
  ouvintes.forEach((fn) => { try { fn(); } catch (e) { /* um ouvinte com defeito nao derruba os outros */ } });
}

export function avisarFotoPerfil(id, avatarUrl) {
  if (!id) return;
  estado = { id, foto: avatarUrl || null, pronto: true };
  notificar();
}

function buscar(id) {
  if (emVoo && emVoo.id === id) return emVoo.promessa;
  const promessa = carregarPerfil()
    .then((p) => {
      if (estado.id === id && estado.pronto) return; // alguem ja avisou algo mais novo enquanto esta busca voava
      estado = { id, foto: (p && p.avatar_url) || null, pronto: true };
      notificar();
    })
    .catch(() => { /* sem foto: o icone continua com a inicial; tenta de novo na proxima vez que o icone aparecer */ })
    .then(() => { if (emVoo && emVoo.id === id) emVoo = null; });
  emVoo = { id, promessa };
  return promessa;
}

export function useFotoPerfil(userId) {
  const [, atualizar] = useState(0);
  useEffect(() => {
    const fn = () => atualizar((n) => n + 1);
    ouvintes.add(fn);
    return () => { ouvintes.delete(fn); };
  }, []);
  useEffect(() => {
    if (!userId) return;
    if (estado.id === userId && estado.pronto) return;
    let token = null;
    try { token = localStorage.getItem('token'); } catch (e) { token = null; }
    if (!token) return;
    buscar(userId);
  }, [userId]);
  return userId && estado.id === userId && estado.pronto ? estado.foto : null;
}

// Mostra a foto; se nao houver foto (ou a imagem quebrar), mostra o que for passado em "fallback" (a inicial do nome).
export function AvatarFoto({ foto, fallback }) {
  const [quebrou, setQuebrou] = useState(false);
  useEffect(() => { setQuebrou(false); }, [foto]);
  if (!foto || quebrou) return fallback;
  return (
    <img
      src={foto}
      alt=""
      data-foto-perfil="sim"
      style={{ width: '100%', height: '100%', maxWidth: 48, maxHeight: 48, objectFit: 'cover', borderRadius: '50%', display: 'block' }}
      onError={() => setQuebrou(true)}
    />
  );
}

// So para os testes: volta ao estado de "nunca buscou".
export function __reiniciar() { estado = { id: null, foto: null, pronto: false }; emVoo = null; ouvintes.clear(); }
